import type { OtPurpose } from "@jti/fe-common";

type ConsentPayload = {
  consents: ConsentItem[];
};

type ConsentItem = {
  id: string;
  accepted: boolean;
};

export const extractConsents = (formData: Record<string, any>, consentFields: OtPurpose[]): ConsentPayload => {
  const consentIds = new Set(consentFields.map((f) => f.id));

  const consents: ConsentItem[] = Object.entries(formData)
    .filter(([key]) => consentIds.has(key))
    .map(([key, value]) => ({
      id: key,
      accepted: !!value?.checked,
    }));

  return { consents };
};
